import { Component, forwardRef, HostBinding, Provider } from '@angular/core';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { ListingDatasource } from 'src/app/_shared/components/listing/listing.datasource';
import { SharedListingData, SharedListingState } from 'src/app/_shared/stores/listing/shared-listing.state';
import cloneDeep from 'lodash-es/cloneDeep';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

export function buildProviders(type): Provider[] {
    return [
        {
            provide: ListingFiltersComponent,
            useExisting: forwardRef(() => type),
        }
    ];
}

// on doit ajouter ce décorateur pour IVY
// le décorateur @Directive ne fonctionne pas dans ce cas de figure
@Component({
    selector: 'app-abstract-listing-filters',
    template: '',
    standalone: false
})
export abstract class ListingFiltersComponent<T = any> extends BaseComponent {

    @HostBinding('class.filters') isFilter = true;

    abstract form: FormGroup;

    datasource: ListingDatasource<T>;

    protected _key: string;

    get key(): string {
        return this._key;
    }

    set key(key: string) {
        this._key = key;
        this.updateForm();
    }

    get filters(): Record<string, any> {
        return cloneDeep(this.snapshot<SharedListingData>(SharedListingState.informations(this.key)).filters) || {};
    }

    /**
     * transform filters with search input
     * @param searchbar value of searchbar input
     */
    abstract transformFilters(searchbar?: string): Record<string, any>;

    abstract searchBarValue(): string;

    abstract cancelFilters(): void;

    abstract resetFilters(): void;

    abstract updateForm(filters?: Record<string, any>): void;

    formatFilters(filters: Record<string, any>): Record<string, any> {
        return filters || {};
    }

    loadFilterRelatedList$(): Observable<any> {
        return of(null);
    }

    checkSaveFilters$(): Observable<any> {
        return of(null);
    }

    countFilters(): number {
        const {filters} = this.snapshot(SharedListingState.informations(this.key));
        return Object.keys(filters || {}).length;
    }

}

